import { connectFela } from '../../dependencies';
import Settings from './Settings';
import * as styles from './Settings.styles';

export default connectFela(styles)(Settings);
